import template from './acris-blog-detail.html.twig';
import './acris-blog-detail.scss';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('acris-blog-detail', {
    template,

    inject: [
        'repositoryFactory',
        'context',
        'systemConfigApiService',
        'mediaDefaultFolderService'
    ],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    data() {
        return {
            item: null,
            isLoading: false,
            isSaveSuccessful: false,
            uploadTag: 'acris-blog-group-upload-tag',
            uploadCoverTag: 'acris-blog-cover-upload-tag',
            mediaModalIsOpen: false,
            mediaItem: null,
            additionalMediaModalIsOpen: false,
            mediaDefaultFolderId: null,
            additionalMediaCollection: null,
            showLayoutModal: false
        };
    },

    watch: {
        'item.media'() {
            if (this.item && this.item.media && this.item.media.id) {
                this.setMediaItem({ targetId: this.item.media.id });
            }
        }
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    computed: {
        publicationDate: {
            get() {
                // if (!this.item.publicationDate) {
                //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                //     this.item.publicationDate = new Date();
                // }

                return this.item.publicationDate;
            },
            set(date) {
                this.item.publicationDate = date;
            },
        },
        activeFrom: {
            get() {
                return this.item.activeFrom;
            },
            set(fromTime) {
                this.item.activeFrom = fromTime;
            },
        },
        activeTo: {
            get() {
                return this.item.activeTo;
            },
            set(toDate) {
                this.item.activeTo = toDate;
            },
        },

        mediaRepository() {
            return this.repositoryFactory.create('media');
        },

        blogRepository() {
            return this.repositoryFactory.create('acris_blog');
        },

        blogCriteria() {
            const criteria = new Criteria(this.page, this.limit);
            criteria.addAssociation('media');
            criteria.addAssociation('additionalMedia');
            criteria.addAssociation('blogGroups');
            criteria.addAssociation('blogAuthor');
            criteria.addAssociation('rules');
            criteria.addAssociation('salesChannels');
            criteria.addAssociation('products');
            criteria.addAssociation('products.options');
            criteria.addAssociation('products.options.group');
            criteria.addAssociation('productStreams');

            return criteria
        },

        blogGroupRepository() {
            return this.repositoryFactory.create('acris_blog_group');
        },

        authorCriteria() {
            const criteria = new Criteria(this.page, this.limit);
            criteria.addSorting(Criteria.sort('lastName', 'DESC'));

            return criteria;
        },

        layoutOptions() {
            return [{
                label: this.$tc('acris-blog.detail.fieldSelectOptionLayoutDefault'),
                value: 'direct'
            }, {
                label: this.$tc('acris-blog.detail.fieldSelectOptionLayoutCms'),
                value: 'layout'
            }]
        },

        productContext() {
            return { ...Shopware.Context.api, inheritance: true }
        },

        productCriteria() {
            const criteria = new Criteria(1, 25);
            criteria.addAssociation('options.group');

            return criteria;
        },

        blogsEntityName() {
            return 'acris_blogs';
        },

        cmsPageRepository() {
            return this.repositoryFactory.create('cms_page');
        },

        cmsPage() {
            return Shopware.Store.get('cmsPage').currentPage;
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.getEntity();
        },

        getEntity() {
            this.isLoading = true;

            this.blogRepository.get(this.$route.params.id, Shopware.Context.api, this.blogCriteria).then((entity) => {
                this.item = entity;
                this.additionalMediaCollection = this.item.additionalMedia;
                if (!this.item.cmsPageId) {
                    this.item.cmsPageId = null;
                }
                this.onLayoutSelect(this.item.cmsPageId);
                this.isLoading = false;
                this.getMediaDefaultFolderId();
            }).catch(() => {
                this.isLoading = false;
            });
        },

        getMediaDefaultFolderId() {
            this.mediaDefaultFolderService.getDefaultFolderId('acris_blogs').then((id) => {
                this.mediaDefaultFolderId = id;
            });
        },

        onSave() {
            this.isLoading = true;
            this.isSaveSuccessful = false;

            return this.blogRepository.save(this.item).then(() => {
                this.getEntity();

                this.isSaveSuccessful = true;
                this.createNotificationSuccess({
                    message: this.$tc('acris-blog.detail.messageSaveSuccess')
                });
            }).catch(() => {
                this.createNotificationError({
                    message: this.$tc('acris-blog.detail.messageSaveError')
                });
                this.isLoading = false;
            });
        },

        abortOnLanguageChange() {
            return this.blogRepository.hasChanges(this.item);
        },

        saveOnLanguageChange() {
            return this.onSave();
        },

        onSalesChannelChange(newSalesChannels) {
            this.item.salesChannels = newSalesChannels;
            this.$emit('update:collection', newSalesChannels);
        },

        onRulesChange(newRule) {
            this.item.rules = newRule;
            this.$emit('update:collection', newRule);
        },

        setMediaItem({ targetId }) {
            if (targetId) {
                this.mediaRepository.get(targetId, Shopware.Context.api).then((response) => {
                    this.mediaItem = response;
                });
                this.item.mediaId = targetId;
            }
        },

        onSelectionChanges(mediaEntity) {
            const media = mediaEntity[0];
            this.item.mediaId = media.id;
            this.mediaItem = media;
        },

        onDropMedia(mediaItem) {
            this.setMediaItem({ targetId: mediaItem.id });
        },

        onUnlinkAvatar() {
            this.mediaItem = null;
            this.item.mediaId = null;
        },

        onOpenMediaModal() {
            this.mediaModalIsOpen = true;
        },

        onCloseModal() {
            this.mediaModalIsOpen = false;
        },

        saveFinish() {
            this.isSaveSuccessful = false;
        },

        onChangeLanguage() {
            this.getEntity();
        },

        onItemProductChange(newItemProducts) {
            this.item.products = newItemProducts;
        },

        onProductStreamChange(newProductStreams) {
            this.item.productStreams = newProductStreams;
        },

        onAdditionalMediaUpload(mediaItems) {
            if (!this.item.additionalMedia) {
                this.item.additionalMedia = [];
            }
            if (!this.item.additionalMedia.find(item => item.id === mediaItems.id)) {
                this.item.additionalMedia.push(mediaItems);
            }
            this.additionalMediaCollection = this.item.additionalMedia;
        },

        onAdditionalMediaRemove(mediaItem) {
            if (this.item.additionalMedia) {
                this.item.additionalMedia = this.item.additionalMedia.filter(item => item.id !== mediaItem.id);
            }
            this.additionalMediaCollection = this.item.additionalMedia;
        },

        onOpenAdditionalMediaModal() {
            this.additionalMediaModalIsOpen = true;
        },

        onAdditionalMediaSort(mediaItems) {
            this.item.additionalMedia = mediaItems;
            this.additionalMediaCollection = this.item.additionalMedia;
        },

        onCloseAdditionalMediaModal() {
            this.additionalMediaModalIsOpen = false;
        },

        onAdditionalMediaSelectionChanges(mediaEntities) {
            let collection = JSON.parse(JSON.stringify(this.item.additionalMedia));
            if (!this.item.additionalMedia) {
                this.item.additionalMedia = [];
            }

            mediaEntities.forEach(mediaEntity => {
                if (!this.item.additionalMedia.find(item => item.id === mediaEntity.id)) {
                    this.item.additionalMedia.push(mediaEntity);
                    collection.push(mediaEntity);
                }
            });

            this.additionalMediaCollection = collection;
        },

        async assignDefaultCMSPage() {
            return new Promise((resolve, reject) => {
                this.systemConfigApiService
                    .getValues('AcrisBlogCS.config')
                    .then(data => {
                        resolve(data['AcrisBlogCS.config.defaultBlogCmsPage']);
                    });
            })
        },

        openLayoutModal() {
            this.showLayoutModal = true;
        },

        openInPageBuilder() {
            if (!this.cmsPage) {
                this.$router.push({name: 'sw.cms.create'});
            } else {
                this.$router.push({name: 'sw.cms.detail', params: {id: this.item.cmsPageId}});
            }
        },

        onLayoutReset() {
            this.item.cmsPageId = null;
            Shopware.Store.get('cmsPage').setCurrentPage(null);
        },

        async onLayoutSelect(selectedLayout) {
            let cmsPageLayoutId = selectedLayout;
            if (selectedLayout === null) {
                cmsPageLayoutId = await this.assignDefaultCMSPage();
            } else {
                this.item.cmsPageId = selectedLayout;
            }

            if (cmsPageLayoutId === null) {
                Shopware.Store.get('cmsPage').setCurrentPage(null);
            } else {
                const criteria = new Criteria(1, 1);
                criteria.setIds([cmsPageLayoutId]);
                criteria.addAssociation('previewMedia');
                criteria.addAssociation('sections');
                criteria.getAssociation('sections').addSorting(Criteria.sort('position'));

                criteria.addAssociation('sections.blocks');
                criteria.getAssociation('sections.blocks')
                    .addSorting(Criteria.sort('position', 'ASC'))
                    .addAssociation('slots');

                this.cmsPageRepository.search(criteria, Shopware.Context.api).then((response) => {
                    Shopware.Store.get('cmsPage').setCurrentPage(response.get(cmsPageLayoutId));
                });
            }
        },

        closeLayoutModal() {
            this.showLayoutModal = false;
        },
    }
});

